<template>
  <ELink
    :href="learnMoreUrl"
    rel="noopener"
    target="_blank"
    data-test-id="ad-learn-more"
    @click="$emit('click')"
  >
    {{ $t('common.generic.learnmore') }}
  </ELink>
</template>

<script>
import ELink from '~~/common/vue/components/link';
import { HELPSCOUT_AD_LEARN_MORE_URL } from '~~/common/js/constants/urls';

export default {
  name: 'EAdLabelLearnMoreLink',
  components: {
    ELink,
  },
  props: {
    trackingActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Helpscout handles localization of the page
      learnMoreUrl: HELPSCOUT_AD_LEARN_MORE_URL,
    };
  },
};
</script>
